import React, { useEffect, useMemo, useRef } from "react";
import QrCodeStyling, {
  DrawType,
  TypeNumber,
  Mode,
  ErrorCorrectionLevel,
  DotType,
  CornerSquareType,
  CornerDotType,
  Options,
} from "qr-code-styling";
import "./QrCode.scss";

type IQrCodeProps = {
  value: string;
  customOptions?: Options;
  className?: string;
};

const DEFAULT_CONFIG_BASE: Options = {
  width: 100,
  height: 100,
  type: "svg" as DrawType,
  image: "/favicon.ico",
  margin: 2,
  qrOptions: {
    typeNumber: 0 as TypeNumber,
    mode: "Byte" as Mode,
    errorCorrectionLevel: "Q" as ErrorCorrectionLevel,
  },
  imageOptions: {
    hideBackgroundDots: true,
    imageSize: 0.4,
    margin: 5,
    crossOrigin: "anonymous",
  },
  dotsOptions: {
    color: "#222222",
    type: "rounded" as DotType,
  },
  backgroundOptions: {
    color: "#FFF",
  },
  cornersSquareOptions: {
    color: "#222222",
    type: "extra-rounded" as CornerSquareType,
  },
  cornersDotOptions: {
    color: "#222222",
    type: "dot" as CornerDotType,
  },
};

function QrCode({ value, customOptions, className }: IQrCodeProps) {
  const qrCodeOptions = useMemo(
    () => ({ ...DEFAULT_CONFIG_BASE, ...customOptions, data: value }),
    [value, customOptions]
  );

  const qrCode = useMemo(
    () => new QrCodeStyling(qrCodeOptions),
    [qrCodeOptions]
  );
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = "";
      qrCode.append(ref.current);
    }
  }, [qrCode]);

  return (
    <div className={`QrCode px-0 ${className || ""}`}>
      <div ref={ref} style={{ height: customOptions?.height }} />
    </div>
  );
}

export default QrCode;
